import { Component, Input, ViewEncapsulation } from '@angular/core';
import { StepperModule } from 'primeng/stepper'
import { TooltipModule } from 'primeng/tooltip';
import { TealCompEncounterDetails, TealCompEncounterUpdate } from '../../../models/encounter';
import { NgClass, NgIf } from '@angular/common';
import { DiaryListComponent, EncounterNotesListComponent, SentEmailListComponent, ReceivedEmailListComponent, EmailService, HarloweSupport, FaxScrollerComponent, BlockUI} from '@harlowe/core';
import { Store } from '@ngxs/store';
import { EncounterAppointmentBlockComponent } from '../../appointments/encounter-appointment-block/encounter-appointment-block.component';
import { PanelModule } from 'primeng/panel';
import { EncounterService, FileUpload } from '../../../services/encounter.service';
import { FacilityLocation, ProviderLocationIdentifier } from '@harlowe/core';
import { EncounterFacilityBlockComponent } from '../../facilities/encounter-facility-block/encounter-facility-block.component';
import { EncounterMedicalBillBlockComponent } from '../../medical/encounter-medical-bill-block/encounter-medical-bill-block.component';
import { ButtonModule } from 'primeng/button';
import { plainToInstance } from 'class-transformer';
import { FileListComponent, IUploadProcessor } from '../../files/file-list/file-list.component';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { EncounterDiaryHandler } from './encounter-diary-handler';
import { EncounterNoteHandler } from './encounter-note-handler';
import { EncounterEmailHandler } from './encounter-email-handler';
import { ReferralService } from '../../../services/referral.service';
import { ClaimService } from '../../../services/claim.service';
import { EncounterFaxHandler } from './encounter-fax-handler';
import { UtilService } from '@harlowe/core';


@Component({
  selector: 'app-encounter-editor',
  standalone: true,
  imports: [StepperModule,TooltipModule, NgClass,NgIf,EncounterNotesListComponent, 
            DiaryListComponent, EncounterAppointmentBlockComponent,
            PanelModule, EncounterFacilityBlockComponent, 
            EncounterMedicalBillBlockComponent, ButtonModule, SentEmailListComponent, 
            FileListComponent, ButtonGroupModule, OverlayPanelModule,
            ReceivedEmailListComponent, FaxScrollerComponent, DialogModule, TabViewModule],
  templateUrl: './encounter-editor.component.html',
  styleUrl: './encounter-editor.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class EncounterEditorComponent
{
  @Input() readonly:boolean = false;
  @Input() set encounter(val:TealCompEncounterDetails | undefined)
  {
    this.editableEncounter = plainToInstance(TealCompEncounterDetails, val);
    console.log(val)
    if(this.editableEncounter)
    {
      this.uploader = new EncounterFileUploader(this.editableEncounter.id,this._encounters);
      this.encounterDiaryHandler = new EncounterDiaryHandler(this.editableEncounter,this._encounters,this._store);
      this.encounterNoteHandler = new EncounterNoteHandler(this.editableEncounter, this._encounters, this._store);
      this.initializeEmailHandler();
      this.initializeFaxHandler();
    }
  }
  
  uploader?: IUploadProcessor;
  emailDialogVisible: boolean = false;
  faxDialogVisible: boolean = false;

  get encounterLocked() : boolean
  {
    return (this.editableEncounter?.status ?? -1) >= 5
  }


  get billReceived() : boolean
  {
    return (this.editableEncounter?.status ?? -1) >= 4
  }

  get encounterComplete() : boolean
  {
    return (this.editableEncounter?.status ?? -1)  == 8
  }

  editableEncounter?: TealCompEncounterDetails;
  encounterDiaryHandler: EncounterDiaryHandler | undefined;
  encounterNoteHandler: EncounterNoteHandler | undefined;
  encounterEmailHandler: EncounterEmailHandler | undefined;
  encounterFaxHandler: EncounterFaxHandler | undefined;

  constructor(private _store: Store, private _encounters: EncounterService, private _referrals: ReferralService, private _emails: EmailService, private _claims: ClaimService, private _util: UtilService)
  {
    
  }

  private async initializeEmailHandler(): Promise<void>
  {
     this.encounterEmailHandler = await new EncounterEmailHandler(this.editableEncounter as TealCompEncounterDetails, this._emails, this._encounters, this._referrals, this._claims, this._store).create(0);
  }

  private async initializeFaxHandler(): Promise<void>
  {
    this.encounterFaxHandler = await new EncounterFaxHandler(this.editableEncounter as TealCompEncounterDetails, this._encounters, this._util, this._store).create();
  }

  proposedProviderSelected(provider:FacilityLocation)
  {
    if(this.editableEncounter && this.editableEncounter.proposedProvider)
    {
      var eu: TealCompEncounterUpdate = new TealCompEncounterUpdate(this.editableEncounter.id);
      eu.proposedProviderId = new ProviderLocationIdentifier(this.editableEncounter.proposedProvider.facility.ein,this.editableEncounter.proposedProvider.facility.npi, this.editableEncounter.proposedProvider.location.id);
      this._encounters.updateEncounter(this.editableEncounter.id,eu);
    }
  }

  confirmedProviderSelected(provider: FacilityLocation)
  {
    if(this.editableEncounter && this.editableEncounter.confirmedProvider)
      {
        var eu: TealCompEncounterUpdate = new TealCompEncounterUpdate(this.editableEncounter.id);
        eu.proposedProviderId = new ProviderLocationIdentifier(this.editableEncounter.confirmedProvider.facility.ein,this.editableEncounter.confirmedProvider.facility.npi, this.editableEncounter.confirmedProvider.location.id);
        this._encounters.updateEncounter(this.editableEncounter.id,eu);    
      }
  }


  async lockEncounter()
  {
    if(this.editableEncounter)
    {
      var e = await this._encounters.lockEncounter(this.editableEncounter.id);
    }
  }

  async unlockEncounter()
  {
    if(this.editableEncounter)
    {
      var e = await this._encounters.unlockEncounter(this.editableEncounter.id);
    }
  }

  async downloadDocuments()
  {
    if(this.editableEncounter)
    {
      this._store.dispatch(new BlockUI.BlockUI);
      var blob = await this._encounters.downloadEncounterDocumentation(this.editableEncounter.id);
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(blob)
      a.href = objectUrl
      a.download = `encounter_${this.editableEncounter.id}_documentation.pdf`;
      a.click();
      URL.revokeObjectURL(objectUrl);

      this._store.dispatch(new BlockUI.UnBlockUI);
    }
  }

  attachmentsChanged(files: HarloweSupport.File[])
  {
    if(this.editableEncounter)
    {
      this.encounterEmailHandler?.updateAttachments("Encounter", files);
    }
  }


  


}


export class EncounterFileUploader implements IUploadProcessor
{


  constructor(private encounterId: number, private _encounterService: EncounterService)
  {

  }

  async deleteFile(file: HarloweSupport.File): Promise<HarloweSupport.File> 
  {
    var deletedFile = await this._encounterService.deleteAttachment(this.encounterId,file.id);
    return deletedFile;
  }

  async uploadFiles(files: FileUpload[]): Promise<HarloweSupport.File[]> 
  {
    if(files && files.length > 0)
    {
      var encounterFiles = await this._encounterService.addAttachments(this.encounterId,files);
      return encounterFiles.map(f => plainToInstance(HarloweSupport.File,f));
    }
    return [];
  }


}